import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, Injector } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AvatarModule, SvgModule } from '@mitel-internal/cloudlink-components-catalogue'; 
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { WebpackTranslateLoader } from './webpack-translate-loader';
import { HttpClient } from '@angular/common/http';
import { NotifierModule } from 'angular-notifier';
import { ClipboardModule } from 'ngx-clipboard';
import { environment } from '../environments/environment';
import { AgmCoreModule } from "@agm/core";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppInjector } from './app-injector';
import { ClConsoleComponentsModule, ClHeaderComponent } from '@mitel/cloudlink-console-components';
import { A11yModule } from '@angular/cdk/a11y';
import { RouterService, TunnelService, WorkflowService } from '@mitel/cloudlink-sdk';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ReportProblemModule } from './modules/report-problem/report-problem.module';

// we want server worker on production and dev but not locally
const enableServerWorker =  (environment.production ||
    window.location.href.indexOf('.dev.mitel.io') > 0 ) 
    ? true
    : false;

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BsDropdownModule.forRoot(),
        FormsModule,
        A11yModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        ClipboardModule,
        AvatarModule,
        SvgModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleApiKey,
            libraries: ["places"]
        }),
        NotifierModule.withConfig({
            position: {
                horizontal: {
                    position: 'middle'
                },
                vertical: {
                    position: 'top'
                }
            },
            behaviour: {
                autoHide: 3000,
                onClick: 'hide',
                onMouseover: 'pauseAutoHide',
                showDismissButton: true,
                stacking: 3
            }
        }),
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader,
                deps: [HttpClient]
            }
        }),
        CoreModule,
        SharedModule,
        ClConsoleComponentsModule,
        ServiceWorkerModule.register('./global-worker.js', {
            enabled: enableServerWorker, // we want it in dev and public
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        ReportProblemModule
    ],
    providers: [
        TunnelService,
        RouterService,
        WorkflowService,
        ClHeaderComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule 
{
	constructor(private injector: Injector) {
        AppInjector.injector = injector;
	}
}